import React from 'react';
import './OverlayContent.less';
import Source from '../../utils/source';
import labelMaker from '../../utils/labelMaker';
import PropTypes from 'prop-types';
import {useMapContext} from '../../context/MapContext';

const OverlayContent = ({name, category, score, distance, source}) => {
    const mapContext = useMapContext();
    if (name.length > 60) {
        name = name.substr(0, 60).concat('...');
    }
    const labels = mapContext.labels;
    const ratedLabel =
        labels && labels.rated ? labels.rated : 'Rated {0} out of 10';
    const fromrentalLabel =
        labels && labels.distance && labels.distance.fromrental
            ? labels.distance.fromrental
            : '{0} from rental';

    const computeFoursquareRating = (rating) => {
        const ratingHtmlElem = `<span class="OverlayContent--foursquare-rating_score">${rating}</span>`;
        return ratedLabel.replace('{0}', ratingHtmlElem);
    };

    return (
        <div className="OverlayContent">
            <div className="OverlayContent--name">{name}</div>
            {source === Source.FOURSQUARE && (
                <div className="OverlayContent--foursquare">
                    <div className="OverlayContent--foursquare-type">{`${category}`}</div>
                    {score > 0 && (
                        <div
                            className="OverlayContent--foursquare-rating"
                            dangerouslySetInnerHTML={{
                                __html: computeFoursquareRating(score),
                            }}
                        />
                    )}
                </div>
            )}
            <div className="OverlayContent--distance">
                {labelMaker(fromrentalLabel, distance)}
            </div>
        </div>
    );
};

OverlayContent.propTypes = {
    name: PropTypes.string.isRequired,
    category: PropTypes.string,
    score: PropTypes.number,
    distance: PropTypes.string,
    source: PropTypes.string,
};

export default OverlayContent;
